import { call, cancel, select } from 'redux-saga/effects';
import { selectConfigValue } from '../../../../selectors/config';
import { selectIsCommercial } from '../../../../selectors/offer';
import { IAppState } from '../../../types';
import { getPublishTerms } from './getPublishTerms';

export function* getPublishTermsCommercial() {
  const state: IAppState = yield select();
  const isCommercial: boolean = selectIsCommercial(state);

  /**
   * @todo Удалить строку с RS
   * @description Данный функционал появился в задаче CD-166174, будет удалён в задаче CD-166304
   */
  const diffPricesPackageEnabled = selectConfigValue('diffPricesPackageEnabled', state);

  /**
   * @todo Удалить условие с RS
   * @description Данный функционал появился в задаче CD-166174, будет удалён в задаче CD-166304
   */
  if (!isCommercial || !diffPricesPackageEnabled) {
    yield cancel();
  }

  yield call(getPublishTerms);
}
